module.exports = {"title":"Больше дольше. Спаси оргазм!","share_title":"Спаси оргазм!","description":"5 историй о том, как сделать свою сексуальную жизнь ярче","image":"https://bolshe-dolshe.passion.ru/img/share_image.jpg","url":"https://bolshe-dolshe.passion.ru/","fbappid":1993488620940379,"trackingID":"UA-105301080-28","clientTrackingID":"","top100":0,"clientTop100":0,"yaMetrika":0}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 343
// module chunks = 0